export default __webpack_public_path__ + "static/pc02-eb234d05ef0e466e35f61c1d23f3dd1f.png";